document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.getElementById('mini-cart');
  const floating = document.querySelector('.floating-actions');
  let floatingHome = null;

  const restoreFloatingHome = () => {
    if (!floating || !floatingHome) return;
    if (floating.parentElement !== floatingHome) {
      floatingHome.appendChild(floating);
    }
    floating.classList.remove('floating-actions--in-drawer');
    document.body.classList.remove('floating-dock-drawer');
  };

  const syncFloatingWithDrawer = () => {
    if (!drawer || !floating) return;
    if (!floatingHome) {
      floatingHome = floating.parentElement;
    }
    if (drawer.hasAttribute('open')) {
      restoreFloatingHome();
      floating.classList.add('floating-actions--cart-open');
    } else {
      floating.classList.remove('floating-actions--cart-open');
    }
  };

  if (drawer && floating) {
    syncFloatingWithDrawer();

    new MutationObserver(syncFloatingWithDrawer).observe(drawer, {
      attributes: true,
      attributeFilter: ['open'],
    });

    drawer.addEventListener('openable-element:open', () => {
      window.setTimeout(syncFloatingWithDrawer, 50);
    });
    drawer.addEventListener('openable-element:close', syncFloatingWithDrawer);
    document.documentElement.addEventListener('cart:refresh', () => {
      window.setTimeout(syncFloatingWithDrawer, 800);
    });
  }

  document.querySelectorAll('.floating-btn.cart-btn').forEach((button) => {
    const formId = button.getAttribute('form');
    if (!formId) return;

    const form = document.getElementById(formId);
    if (!form) return;

    const defaultLabel = button.textContent.trim();
    let addedTimeout;

    const showAddedState = () => {
      button.textContent = 'Added';
      button.classList.add('floating-btn--added');
      window.clearTimeout(addedTimeout);
      addedTimeout = window.setTimeout(() => {
        button.textContent = defaultLabel;
        button.classList.remove('floating-btn--added');
        button.removeAttribute('aria-busy');
        if (form.querySelector('[name="id"]:not([disabled])')) {
          button.disabled = false;
        }
      }, 1500);
    };

    form.addEventListener('submit', (event) => {
      if (event.submitter !== button) return;
      window.clearTimeout(addedTimeout);
      button.setAttribute('aria-busy', 'true');
      button.disabled = true;
    });

    form.addEventListener('variant:added', () => {
      if (!button.hasAttribute('aria-busy')) return;
      showAddedState();
    });

    form.addEventListener('cart-notification:show', (event) => {
      if (!button.hasAttribute('aria-busy')) return;
      if (event.detail?.status === 'success') {
        if (!button.classList.contains('floating-btn--added')) {
          showAddedState();
        }
      } else if (event.detail?.status === 'error') {
        window.clearTimeout(addedTimeout);
        button.textContent = defaultLabel;
        button.classList.remove('floating-btn--added');
        button.removeAttribute('aria-busy');
        button.disabled = false;
      }
    });
  });

  document.addEventListener('openable-element:open', (event) => {
    if (event.target.tagName === 'PRODUCT-IMAGE-ZOOM') {
      document.body.classList.add('product-zoom-is-open');
    }
  });

  document.addEventListener('openable-element:close', (event) => {
    if (event.target.tagName === 'PRODUCT-IMAGE-ZOOM') {
      document.body.classList.remove('product-zoom-is-open');
    }
  });

  document.addEventListener('click', (event) => {
    const mediaMain = event.target.closest('.product__media-main');
    if (!mediaMain) return;

    const selectedSlide = mediaMain.querySelector('.product__media-item.is-selected');
    if (!selectedSlide || selectedSlide.getAttribute('data-media-type') !== 'image') return;

    const zoomButton = mediaMain.querySelector('.product__zoom-button');
    if (!zoomButton || zoomButton.hidden) return;

    event.preventDefault();
    zoomButton.click();
  });
});